import { Button, Upload as UploadAntd, Image } from "antd";
import React, { useState, useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { ShowToast, Severty } from "../helper/toast";
import { S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";

const s3Config = {
  region: "us-east-1",
  credentials: {
    accessKeyId: "IJTXH751MBXUWMTWM0SF",
    secretAccessKey: "lfTPRJ2PqAxsp3poTW9YlHktgaL1cFkLup8LidW9",
  },
  endpoint: "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/",
  forcePathStyle: true,
};

const s3Client = new S3Client(s3Config);
export const SingleVideoUpload = ({
  fileType,
  value,
  imageType,
  btnName,
  onChange,
  size = 50,
  isDimension = false,
  setLoading,
  ...props
}) => {
  const [file, setFile] = useState([]);

  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = document.createElement("img");

      img.onload = () => {
        if (img.width === 600 && img.height === 600) {
          resolve();
        } else {
          reject(
            `Please upload an image with dimensions 600X600. uploaded image is ${img.width} X ${img.height}`
          );
        }
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const beforeUpload = async (file) => {
    try {
      if (fileType.includes(file.type)) {
      } else {
        ShowToast("File format is not correct", Severty.ERROR);
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < size;

      if (!isLt2M) {
        ShowToast(`Image must be smaller than ${size} MB!`, Severty.ERROR);
        return false;
      }
      isDimension && (await checkImageDimensions(file));
      return true;
    } catch (err) {
      ShowToast(err, Severty.ERROR);
      return false;
    }
  };

  const onRemove = () => {
    setFile([]);
    if (onChange) {
      onChange([]);
    }
  };

  useEffect(() => {
    if (!value || value.length === 0) {
      setFile([]);
    } else {
      const formattedFileList = Array.isArray(value)
        ? value.map((item, index) => ({
          uid: item.uid || `-1-${index}`,
          name: item.name || `image-${index}.png`,
          status: "done",
          url: item.url || item,
          thumbUrl: item.thumbUrl || item.url || item,
        }))
        : [
          {
            uid: "-1",
            name: "Video.mp4",
            status: "done",
            url: value,
            thumbUrl: value,
          },
        ];
      setFile(formattedFileList);
    }
  }, [value]);

  const handleImgChange = async (event) => {
    const { file } = event;
    setFile([file]);
    if (setLoading) setLoading(true);

    try {
      // 1️⃣ Generate a unique file name
      const fileName = `${Date.now()}-${file.name}`;

      // 2️⃣ Use AWS SDK v3 to upload to S3
      const parallelUpload = new Upload({
        client: s3Client,
        params: {
          Bucket: "your-bucket-name", // ✅ Replace with your S3 bucket name
          Key: `uploads/${fileName}`, // You can change folder name
          Body: file,
          ContentType: file.type,
          ACL: "public-read", // Make file publicly accessible (optional)
        },
      });

      parallelUpload.on("httpUploadProgress", (progress) => {
        console.log("Upload progress:", progress);
      });

      const uploadResult = await parallelUpload.done();

      // 3️⃣ Get the file's public URL
      const s3FileUrl = `https://${s3Config.endpoint.replace(/^https?:\/\//, '')}${uploadResult.Key}`;

      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: s3FileUrl,
        thumbUrl: s3FileUrl,
      };

      setFile([fileData]);
      if (onChange) onChange([fileData]);

      console.log("✅ S3 Upload Complete:", fileData);
    } catch (err) {
      console.error("❌ S3 Upload Error:", err);
      ShowToast("Failed to upload to S3", Severty.ERROR);
    } finally {
      if (setLoading) setLoading(false);
    }
  };


  return (
    <UploadAntd
      listType="picture"
      maxCount={1}
      beforeUpload={beforeUpload}
      customRequest={handleImgChange}
      onRemove={onRemove}
      fileList={file}
      {...props}
    >
      {file && file.length > 0 && file !== "" ? null : (
        <Button icon={<UploadOutlined />}>
          {" "}
          {btnName ? `Upload ${btnName}` : ""}
        </Button>
      )}
    </UploadAntd>
  );
};

export const SingleImageUpload = ({
  fileType,
  value,
  imageType,
  btnName,
  onChange,
  size = 2, // default 2MB
  isDimension = false,
  setLoading,
  ...props
}) => {
  const [file, setFile] = useState([]);

  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        if (img.width === 600 && img.height === 600) {
          resolve();
        } else {
          reject(
            `Please upload an image with dimensions 600x600. Uploaded image is ${img.width}x${img.height}`
          );
        }
      };
      img.src = URL.createObjectURL(file);
    });
  };

  const beforeUpload = async (file) => {
    try {
      if (!fileType.includes(file.type)) {
        ShowToast("File format is not correct", Severty.ERROR);
        return UploadAntd.LIST_IGNORE;
      }

      const isLtSize = file.size / 1024 / 1024 < size;
      if (!isLtSize) {
        ShowToast(`Image must be smaller than ${size} MB!`, Severty.ERROR);
        return UploadAntd.LIST_IGNORE;
      }

      if (isDimension) {
        await checkImageDimensions(file);
      }

      return true;
    } catch (err) {
      ShowToast(err, Severty.ERROR);
      return UploadAntd.LIST_IGNORE;
    }
  };

  const onRemove = () => {
    setFile([]);
    if (onChange) onChange([]);
  };

  useEffect(() => {
    if (!value || value.length === 0) {
      setFile([]);
    } else {
      const formattedFileList = Array.isArray(value)
        ? value.map((item, index) => ({
          uid: item.uid || `-1-${index}`,
          name: item.name || `image-${index}.png`,
          status: "done",
          url: item.url || item,
          thumbUrl: item.thumbUrl || item.url || item,
        }))
        : [
          {
            uid: "-1",
            name: "image.png",
            status: "done",
            url: value,
            thumbUrl: value,
          },
        ];
      setFile(formattedFileList);
    }
  }, [value]);

  const handleImgChange = async (options) => {
    console.log("handle-options", options)
    const { file, onSuccess, onError } = options;
    const rawFile = file.originFileObj || file;
    setFile([file]);

    if (setLoading) setLoading(true);

    try {
      const fileName = `${Date.now()}-${rawFile.name}`;

      const parallelUpload = new Upload({
        client: s3Client,
        params: {
          Bucket: "invent-colab-obj-bucket",
          Key: `GYM - TV/${fileName}`,
          Body: rawFile,
          ContentType: rawFile.type,
          ACL: "public-read",
        },
      });

      parallelUpload.on("httpUploadProgress", (progress) => {
        console.log("Upload progress:", progress);
      });

      const uploadResult = await parallelUpload.done();

      const s3FileUrl = uploadResult.Location;

      const fileData = {
        uid: file.uid,
        name: rawFile.name,
        status: "done",
        url: s3FileUrl,
        thumbUrl: s3FileUrl,
      };

      setFile([fileData]);
      if (onChange) onChange([fileData]);
      if (onSuccess) onSuccess(fileData, file);

      console.log("✅ S3 Upload Complete:", fileData);
    } catch (err) {
      console.error("❌ S3 Upload Error:", err);
      ShowToast("Failed to upload to S3", Severty.ERROR);
      if (onError) onError(err);
    } finally {
      if (setLoading) setLoading(false);
    }
  };

  console.log("single-file", file, value)
  return (
    <UploadAntd
      listType="picture"
      maxCount={1}
      beforeUpload={beforeUpload}
      customRequest={handleImgChange}
      onRemove={onRemove}
      fileList={file}
      {...props}
    >
      {file && file.length > 0 ? null : (
        <Button >
          Upload
        </Button>
      )}
    </UploadAntd>
  );
};

export default SingleImageUpload;
